import { render, staticRenderFns } from "./TeamReview.vue?vue&type=template&id=db4fa6d2&scoped=true"
import script from "./TeamReview.vue?vue&type=script&lang=js"
export * from "./TeamReview.vue?vue&type=script&lang=js"
import style0 from "./TeamReview.vue?vue&type=style&index=0&id=db4fa6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4fa6d2",
  null
  
)

export default component.exports